import { render, staticRenderFns } from "./OrderButton.vue?vue&type=template&id=56a717f2"
import script from "./OrderButton.vue?vue&type=script&lang=js"
export * from "./OrderButton.vue?vue&type=script&lang=js"
import style0 from "./OrderButton.vue?vue&type=style&index=0&id=56a717f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports